/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../../atoms/formEnums/formValidation';
import InputText from '../../atoms/inputText/inputText';
import InputTag from '../../atoms/inputTag/inputTag';
import Label from '../../atoms/label/label';
import { IconType } from '../../atoms/icon/icon';
import { ButtonTheme } from '../../atoms/button/button';
import './formInputText.scss';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { unset } from 'lodash';

export const FormInputTextType = {
  TEXT: 'text',
  COLOR: 'color',
  TIME: 'time',
  EMAIL: 'email',
  NUMBER: 'number',
  PASSWORD: 'password',
  URL: 'url',
  COLOR_PICKER: 'color_picker',
};

/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormInputText = (props) => {
  const {
    id,
    name,
    type,
    validation,
    errorText,
    label,
    placeholder,
    helpText,
    value,
    onChange,
    configFile,
    defaultValue,
    pattern,
    multiple,
    multiline,
    disabled,
    refreshData,
    hidden,
    importButton,
    configFileImport,
    fieldToImport,
    min,
    max,
    avoidAutofill,
    encrypt,
    protect
  } = props;

  const childRef = useRef();

  // const [valueState, setValueState] = useState(value !== '' ? value : defaultValue);
  const [valueState, setValueState] = useState(value !== '' ? value : defaultValue);
  const [isProtected, setIsProtected] = useState(()=>protect);
  
  const handleOnCloseLoadFromCatalog = (data) => {
    if (data !== undefined && data[configFile.mainAttribute] !== undefined) {
      childRef.current.updateValue(data[configFile.mainAttribute]);
      onChange({ target: { value: data[configFile.mainAttribute] } });
    }
  };
  useEffect(() => {
    if (value !== valueState) {
      let v=value!==''?value:defaultValue;
      setValueState(v);
      childRef.current.updateValue(v);
    }
  }, [value]);

  useEffect(() => {
    if(refreshData){
      unset(refreshData,"updated");
      setValueState(refreshData);
      childRef.current.updateValue(refreshData);
      onChange({ target: { value: refreshData} })
    }
    
  }, [refreshData]);
  return (
    <div className={`form-group row text-${validation} ${(hidden?"form-input-text__hidden":"")}`}>
      { label !== ''
        && (
          <Label helpText={helpText} protect={protect} isProtected={isProtected} setIsProtected={setIsProtected}>{label}</Label>
        )}
      <div className="col-sm-8">
        { multiple
        && (
          <InputTag
              ref={childRef}
              name={name}
              id={id}
              type={type}
              className={(configFile) !== undefined ? 'form-input-text__input' : ''}
              validation={validation}
              placeholder={placeholder}
              value={valueState}
              onChange={onChange}
            />
        )}
        { (configFile || multiple) === undefined
          && (
            <InputText
              id={id}
              ref={childRef}
              name={name}
              type={type}
              className={(configFile) !== undefined ? 'form-input-text__input' : ''}
              validation={validation}
              placeholder={placeholder}
              value={valueState}
              onChange={onChange}
              pattern={pattern}
              disabled={disabled}
              multiline={multiline}
              importButton={importButton}
              configFileImport={configFileImport}
              fieldToImport={fieldToImport}
              min={min}
              max={max}
              avoidAutofill={avoidAutofill}
              blockInput={isProtected}
            />
          )}
        { (configFile) !== undefined
          && (<InputText
              id={id}
              ref={childRef}
              name={name}
              type={type}
              className={(configFile) !== undefined ? 'form-input-text__input' : ''}
              validation={validation}
              placeholder={placeholder}
              value={valueState}
              onChange={onChange}
              pattern={pattern}
              disabled
              multiline={multiline}
              min={min}
              max={max}
              avoidAutofill={avoidAutofill}
            />
          )}
        { configFile !== undefined
          && (
          <LoadFromCatalogButton
            id={`${id}-button`}
            onClose={handleOnCloseLoadFromCatalog}
            label={label}
            configFile={configFile}
            buttonText=""
            icon={IconType.SEARCH}
            buttonTheme={ButtonTheme.INFO}
          />
          )}
        { (validation === FormValidation.ERROR || validation === FormValidation.WARNING)
          && (
            <small className="form-text">{errorText}</small>
          )}
      </div>
    </div>
  );
};

FormInputText.propTypes = {
  /**
   * id of input field
   */
  id: PropTypes.string,
  /**
   * Name of input field
   */
  name: PropTypes.string.isRequired,
  /**
   * HTML input type, it is a FormInputTypes.TEXT_INPUT enum
   */
  type: PropTypes.oneOf(Object.values(FormInputTextType)),
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Placeholder inside the HTML input
   */
  placeholder: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({}),
  /**
   * Default value
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * the input regular expression to control
   */
  pattern: PropTypes.instanceOf(RegExp),

  multiline:PropTypes.bool,
};

FormInputText.defaultProps = {
  id: '',
  type: FormInputTextType.TEXT,
  validation: FormValidation.PENDING,
  errorText: '',
  label: '',
  placeholder: '',
  helpText: '',
  value: '',
  onChange: () => {},
  configFile: undefined,
  defaultValue: '',
  pattern: undefined,
  multiline:false,
};

export default FormInputText;
